import { Type } from '@angular/core';

import { IChatTemplate, ChatTemplateConfig } from '../types/chat-template.types';

/** Реестр компонентов и конфигурация отображения одного режима чата. */
export class ChatTemplate implements IChatTemplate {
    private readonly registry = new Map<string, Type<unknown>>();

    public readonly config: ChatTemplateConfig;

    public constructor(config: ChatTemplateConfig) {
        this.config = config;
    }

    /**
     * Зарегистрировать компонент для типа сообщения.
     * Вызывается в конструкторе подкласса.
     */
    protected register(type: string, component: Type<unknown>): void {
        this.registry.set(type, component);
    }

    /**
     * Вернуть Angular-компонент для указанного типа сообщения.
     * @throws {Error} если тип не зарегистрирован
     */
    public getComponent(messageType: string): Type<unknown> {
        const component = this.registry.get(messageType);

        if (!component) {
            throw new Error(`ChatTemplate: no component registered for type "${messageType}"`);
        }

        return component;
    }
}
